import React from "react";
import { Link } from "react-router-dom";
import "../../assets/css/legal.css";
import minutezillaLogoWhite from "../../assets/images/minutezilla-logo-white.png";

const providerRows = [
  { label: "Name", value: "Sivaprasad Sisupalan" },
  { label: "Adresse", value: "Speckenkamp 12, 38442 Wolfsburg, Deutschland" },
  { label: "E-Mail", value: "kontakt@minutezilla.com", href: "mailto:kontakt@minutezilla.com" },
  { label: "Telefon", value: "+49 157 79151890" },
];

const sections = [
  {
    title: "Haftung für Inhalte",
    paragraphs: [
      "Als Diensteanbieter bin ich gemäß den allgemeinen Gesetzen für eigene Inhalte auf diesen Seiten verantwortlich.",
      "Ich übernehme keine Gewähr für die Aktualität, Vollständigkeit und Richtigkeit der bereitgestellten Inhalte. Bei Bekanntwerden konkreter Rechtsverletzungen werden die betreffenden Inhalte unverzüglich entfernt.",
    ],
  },
  {
    title: "Haftung für Links",
    paragraphs: [
      "Wir verlinken in unserem Angebot auf Webseiten Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber verantwortlich.",
      "Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist ohne konkrete Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Sollten Sie der Meinung sein, dass einer der Links oder bereitgestellten Informationen gegen geltendes Recht verstößt oder unangemessene Inhalte enthält, informieren Sie uns bitte über die angegebenen Kontaktinformationen.",
    ],
  },
  {
    title: "Urheberrecht",
    paragraphs: [
      "Die auf dieser Website veröffentlichten Inhalte und Werke unterliegen dem deutschen Urheberrecht. Sollten Ihnen mögliche Rechtsverletzungen auffallen, senden Sie bitte einen Hinweis an die oben genannte Kontaktadresse.",
    ],
  },
  {
    title: "Streitbeilegung",
    paragraphs: [
      "Hinweis gemäß § 36 Verbraucherstreitbeilegungsgesetz (VSBG).",
      "Ich bin nicht verpflichtet und nicht bereit, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.",
    ],
  },
  {
    title: "Kontakt",
    paragraphs: ["E-Mail: kontakt@minutezilla.com"],
  },
];

export default function Impressum() {
  return (
    <div className="legal-root">
      <div className="legal-topbar">
        <Link to="/login" className="legal-topbar-brand">
          <div className="legal-topbar-logo">
            <img src={minutezillaLogoWhite} alt="Minutezilla" className="legal-topbar-logo__img" />
          </div>
        </Link>
        <Link to="/login" className="legal-topbar-back">
          ← Zurück zum Login
        </Link>
      </div>

      <div className="legal-wrapper">
        <div className="legal-header">
          <div className="legal-badge">Rechtliches</div>
          <h1 className="legal-title">Impressum</h1>
          <p className="legal-subtitle">Angaben gemäß § 5 DDG</p>
          <p className="legal-updated">Stand: 24. Mai 2026</p>
        </div>

        <div className="legal-content">
          <div className="legal-section">
            <h2>Angaben zum Anbieter</h2>
            <p>
              Diensteanbieter gemäß § 5 DDG für diese Website und die Minutezilla-Dienste ist:
            </p>
            <div className="legal-infobox">
              {providerRows.map((row) => (
                <p key={row.label} style={{ marginBottom: 10 }}>
                  <strong>{row.label}:</strong>{" "}
                  {row.href ? <a href={row.href}>{row.value}</a> : row.value}
                </p>
              ))}
            </div>
          </div>

          {sections.map((section) => (
            <div className="legal-section" key={section.title}>
              <h2>{section.title}</h2>
              {section.paragraphs.map((paragraph) => (
                <p key={paragraph}>{paragraph}</p>
              ))}
            </div>
          ))}
        </div>

        <div className="legal-footer-strip">
          <p>&copy; {new Date().getFullYear()} Minutezilla. Alle Rechte vorbehalten.</p>
          <div>
            <Link to="/impressum">Impressum</Link>
            <Link to="/datenschutz">Datenschutz</Link>
            <Link to="/agb">AGB</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
